module.exports = __webpack_public_path__ + "img/f3.7d00cd22.png";